import React from 'react';

import MessageHeader from './components/message-header/MessageHeader';
import ManualMessage from './components/manual-message/ManualMessage';
import MobileSessionHistory from './components/mobile-session-history/MobileSessionHistory';

import scss from './MessageSection.module.scss';

function MessageSection() {
  return (
    <div className={scss.wrapper}>
      <MessageHeader />

      <div className={scss.content}>
        <ManualMessage />
      </div>

      <MobileSessionHistory />
    </div>
  );
}

export default MessageSection;
